<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { IconEPC } from '@ui-kit';
  import { ScanModal } from '../ScanModal';

  const { push } = useRouter();
</script>

<template>
  <ScanModal
    :title="$t('Отсканируйте EPC метку')"
    :subtitle="$t('Проверим, корректна ли связка между ней и КИЗом')"
    :btnTitle="$t('Отмена')"
    @click:btn="push('/main?checkPairs=true')"
    @click:back="push('/main?checkPairs=true')"
    data-testid="scan-epc"
  >
    <template #icon>
      <IconEPC />
    </template>
    <slot />
  </ScanModal>
</template>